/**
 * MaskedViewBadge - 脱敏视图指示器
 * 当用户以 Manager 角色查看时显示
 */
import { Shield, Eye } from 'lucide-react'
import { motion } from 'framer-motion'

interface MaskedViewBadgeProps {
  className?: string
  showTooltip?: boolean
}

export default function MaskedViewBadge({ 
  className = '',
  showTooltip = true 
}: MaskedViewBadgeProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 bg-amber-100 text-amber-700 rounded-full text-xs font-medium ${className}`}
      title={showTooltip ? '当前为脱敏视图，敏感信息已隐藏' : undefined}
    >
      <Shield className="w-3.5 h-3.5" />
      <span>脱敏视图</span>
    </motion.div>
  )
}

/**
 * MaskedFieldIndicator - 脱敏字段指示器
 * 在具体字段旁边显示"已脱敏"标记
 */
export function MaskedFieldIndicator({ className = '' }: { className?: string }) {
  return (
    <span 
      className={`inline-flex items-center gap-1 text-xs text-amber-600 ${className}`}
      title="此字段已脱敏"
    >
      <Eye className="w-3 h-3" />
      <span>已脱敏</span>
    </span>
  )
}

/**
 * MaskedViewBanner - 脱敏视图横幅
 * 页面顶部显示的脱敏提示
 */
export function MaskedViewBanner() {
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2">
      <div className="flex items-center justify-center gap-2 text-amber-700">
        <Shield className="w-4 h-4" />
        <span className="text-sm">
          您正在以<strong>经理/教练</strong>角色查看，部分敏感信息已脱敏
        </span>
      </div>
    </div>
  )
}

